import React, { FC, createContext, useContext } from 'react';
import { cx } from 'emotion';
import { SingleOption } from 'app/pages/Survey/Subject/elements';
import { countChinese } from 'app/shared/i18n';
import { NestChildProps, NestParentProps } from '../types';
import { createNest } from '../createNest';
import { useNestAnswer } from '../hooks';
import { useStyles } from './styles';

const maxLabelChineseCount = 4;

const NestDesktopStylesContext = createContext<ReturnType<typeof useStyles>>(
  {} as ReturnType<typeof useStyles>
);

const NestDesktopChild: FC<NestChildProps> = ({ options }) => {
  const { id, text, valueFromAnswer, onChange } = useNestAnswer();
  const styles = useContext(NestDesktopStylesContext);

  return (
    <tr className={styles.tr} data-subject-id={id}>
      <td
        className={cx(
          styles.categoryText,
          styles.thtd,
          styles.withPadding,
          styles.firstColumn
        )}
      >
        <div className={styles.categoryTextContainer}>{text}</div>
      </td>
      {options.map(({ Id, label, value }) => {
        const checked = valueFromAnswer === value;
        const labelChineseCount = countChinese(label);
        const minWidth =
          (labelChineseCount >= maxLabelChineseCount
            ? maxLabelChineseCount
            : labelChineseCount) + 1;
        const style = { minWidth: `${minWidth}em` };
        return (
          <td key={value} className={styles.thtd} style={style}>
            <div className={styles.center}>
              <SingleOption
                Id={Id}
                value={value}
                className={styles.radioClassName}
                inverse
                checked={checked}
                onChange={onChange}
              />
            </div>
          </td>
        );
      })}
    </tr>
  );
};

const NestDesktop: FC<NestParentProps> = ({ children, options }) => {
  const styles = useStyles([options.length]);

  return (
    <table className={styles.table}>
      <tbody>
        <tr className={styles.tr}>
          <th className={cx(styles.thtd, styles.th, styles.firstColumn)} />
          {options.map(({ label, value }) => (
            <th
              key={value}
              className={cx(
                styles.thtd,
                styles.textClassName,
                styles.withPadding,
                styles.th
              )}
            >
              {label}
            </th>
          ))}
        </tr>
        <NestDesktopStylesContext.Provider value={styles}>
          {children}
        </NestDesktopStylesContext.Provider>
      </tbody>
    </table>
  );
};

export default createNest(NestDesktopChild, NestDesktop);
